"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionContexts = exports.Context = void 0;
var Context;
(function (Context) {
    Context["Basket"] = "BASKET";
    Context["Order"] = "ORDER";
    Context["Subscription"] = "SUBSCRIPTION";
    Context["SwitchSubscription"] = "SWITCH_SUBSCRIPTION";
    Context["SubscriptionBasket"] = "SUBSCRIPTION_BASKET";
    Context["User"] = "USER";
    Context["UserRegistration"] = "USER_REGISTRATION";
})(Context || (exports.Context = Context = {}));
exports.SubscriptionContexts = [Context.Subscription, Context.SwitchSubscription, Context.SubscriptionBasket];
exports.default = Context;
//# sourceMappingURL=Context.js.map